import classNames from "classnames";
import type { AnniversaryEvent, BirthdayEvent, NoteEvent } from "@/services/api";
import type { Dayjs } from "dayjs";
import type { FC } from "react";
import styles from "./styles.module.scss";
import { CalendarEventItem } from "./components";

type CalendarEventListDesktop = {
  date: Dayjs;
  events: BirthdayEvent[] | AnniversaryEvent[] | NoteEvent[];
};

export const CalendarEventListDesktop: FC<CalendarEventListDesktop> = ({ events, date }) => {
  return (
    <ul className={classNames(styles["todo-list"])}>
      {events.map((event) => {
        const id =
          event.type === "anniversary" || event.type === "birthday" ? event.personId : event.noteId;
        const anniversaryRecord = event.type === "anniversary" ? event : undefined;
        return (
          <CalendarEventItem
            anniversaryRecord={anniversaryRecord}
            key={id}
            type={event.type}
            id={id}
            currentDate={date}
          />
        );
      })}
    </ul>
  );
};
